import src from "IMAGE";
export default { src, width: 261, height: 61, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAPUlEQVR42k3KwQ0AEAxA0SqJVEgkOgBJF3B3xmydmmP/9T9oh5UkrVAD++wrOECwtctaZtkfCXUaGDHa/wCjEAQHcGSc+QAAAABJRU5ErkJggg=="};
